// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1USxV","header":"MessagesList_header__DdulQ","chat":"MessagesList_chat__1-_lW"};